if (!customElements.get('begode-slideshow')) {
  customElements.define('begode-slideshow',class extends HTMLElement {
    connectedCallback(){
      this.abort=new AbortController();
      const on=(el,event,fn)=>el?.addEventListener(event,fn,{signal:this.abort.signal});
      if(this.dataset.layout==='stacked'){
        const tickers=Array.from(this.querySelectorAll('[data-stacked-ticker]'));
        const measure=()=>tickers.forEach(t=>{
          this.layoutTicker(t);
        });
        this.observer=new ResizeObserver(measure);this.observer.observe(this);measure();return;
      }
      this.slides=Array.from(this.querySelectorAll('.begode-slideshow__slide'));
      this.track=this.querySelector('.begode-slideshow__track');
      this.ticker=this.querySelector('.begode-slideshow__ticker');
      this.marquee=this.querySelector('.begode-slideshow__marquee');
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
      this.index=0;this.paused=this.reduced.matches;
      on(this.querySelector('[data-next]'),'click',()=>this.show(this.index+1));
      on(this.querySelector('[data-previous]'),'click',()=>this.show(this.index-1));
      const viewport=this.querySelector('.begode-slideshow__viewport');
      on(viewport,'pointerdown',e=>{if(e.isPrimary&&e.pointerType!=='mouse')this.start={x:e.clientX,y:e.clientY};});
      on(viewport,'pointerup',e=>{
        if(!this.start)return;
        const dx=e.clientX-this.start.x,dy=e.clientY-this.start.y;this.start=null;
        if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3){this.swipeUntil=Date.now()+400;this.show(this.index+(dx<0?1:-1));}
      });
      on(viewport,'pointercancel',()=>{this.start=null;});
      on(viewport,'click',e=>{if(Date.now()<this.swipeUntil){e.preventDefault();this.swipeUntil=0;}});
      on(this,'keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}});
      on(document,'visibilitychange',()=>this.schedule());
      on(this.reduced,'change',()=>{this.paused=this.reduced.matches;this.schedule();});
      on(document,'shopify:block:select',e=>{
        const index=this.slides.findIndex(slide=>slide.dataset.blockId===e.detail.blockId);
        if(index>=0){this.paused=true;this.show(index);}
      });
      this.observer=new ResizeObserver(()=>this.measureTicker());this.observer.observe(this);
      this.show(0);
    }
    show(index){
      if(!this.slides.length)return;
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{
        slide.classList.toggle('is-active',i===this.index);
        slide.setAttribute('aria-hidden',String(i!==this.index));slide.inert=i!==this.index;
      });
      this.track.style.transform=`translateX(-${this.index*100}%)`;
      const counter=this.querySelector('[data-counter]');if(counter)counter.textContent=`${this.index+1} / ${this.slides.length}`;
      const text=this.slides[this.index].querySelector('[data-ticker-text]').content.textContent.trim();
      this.ticker.hidden=!text;
      this.querySelector('[data-ticker-accessible]').textContent=text;
      this.marquee.querySelectorAll('span').forEach(span=>{span.textContent=text;});
      this.marquee.style.animation='none';
      this.measureTicker();
      void this.marquee.offsetWidth;
      this.marquee.style.animation='';
      this.schedule();
    }
    measureTicker(){
      if(this.ticker.hidden)return;
      this.layoutTicker(this.ticker);
    }
    layoutTicker(ticker){
      const spans=[...ticker.querySelectorAll('.begode-slideshow__marquee span')];
      if(!spans.length)return;
      spans.forEach(span=>{span.style.width='max-content';span.style.minWidth='0';});
      const width=Math.max(ticker.clientWidth,Math.ceil(spans[0].getBoundingClientRect().width));
      spans.forEach(span=>{span.style.width=`${width}px`;});
      const speed=Number(this.dataset.tickerSpeed)||40;
      const start=Math.max(0,ticker.clientWidth/4-parseFloat(getComputedStyle(spans[0]).paddingLeft));
      ticker.style.setProperty('--ticker-start',`${start}px`);
      ticker.style.setProperty('--ticker-entry-duration',`${start/speed}s`);
      ticker.style.setProperty('--ticker-duration',`${width/speed}s`);
    }
    schedule(){
      clearTimeout(this.timer);
      if(this.dataset.autoplay==='true'&&this.slides.length>1&&!this.paused&&!document.hidden&&!window.Shopify?.designMode)
        this.timer=setTimeout(()=>this.show(this.index+1),(Number(this.dataset.seconds)||6)*1000);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();}
  });
}
